import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export class VolConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Vol
  static abbreviation = 'vol'
  static label = 'Volume'
  static shortLabel = 'Volume'
}
